import React from 'react';

const PrimaryDINumber = ({
    AppContext,
    fieldTitle = "Primary DI Number"
}) => {

	return <>

		<div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <input type="text" className="form-control rounded-0 form-control-md" disabled title="You can edit this in the Product Details" value={AppContext.currentItem.UDIDI} />

                </div>
            </div>
        </div>


		
	</>
}


export default PrimaryDINumber;
